import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, FileText } from "lucide-react";

export default function DocumentsStep({ files, setFiles, loading, onSubmit, onSkip }) {
  return (
    <form onSubmit={onSubmit} className="space-y-5">
      <div>
        <Label className="text-xs uppercase tracking-widest text-slate-600 font-semibold">Salary Slips (Last 3 months)</Label>
        <Input data-testid="salary-slip-upload" type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={e => setFiles({...files, salary_slip: e.target.files[0]})} className="mt-2 bg-white/50 border-slate-200 focus:border-blue-500 h-12 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" />
      </div>
      <div>
        <Label className="text-xs uppercase tracking-widest text-slate-600 font-semibold">Bank Statements (Last 6 months)</Label>
        <Input data-testid="bank-statement-upload" type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={e => setFiles({...files, bank_statement: e.target.files[0]})} className="mt-2 bg-white/50 border-slate-200 focus:border-blue-500 h-12 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100" />
      </div>
      <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 flex items-start gap-2">
        <FileText className="h-4 w-4 text-slate-500 mt-0.5 flex-shrink-0" />
        <p className="text-sm text-slate-600">Accepted: PDF, JPG, PNG (Max 10MB each)</p>
      </div>
      <button type="submit" data-testid="upload-docs-btn" disabled={loading} className="btn-gradient w-full h-14 rounded-xl font-semibold text-lg shadow-xl hover:shadow-2xl transition-all duration-300 disabled:opacity-50">
        {loading ? <Loader2 className="h-5 w-5 animate-spin mx-auto" /> : "Upload & Continue"}
      </button>
      <button
        type="button"
        onClick={onSkip}
        data-testid="skip-docs-btn"
        className="w-full flex items-center justify-center gap-1.5 text-sm text-blue-600 hover:text-blue-800 font-medium hover:underline transition-colors"
      >
        Skip for now
      </button>
    </form>
  );
}
